import { paramCase } from 'change-case'
import { useState } from 'react'
import { BackboneUserModel, getBackboneWindow } from '@opallabs/brown-dwarf'
import { kuiperClassNames } from '@opallabs/kuiper'
import { DesktopSingle, MobileSingle } from './displays'
import { baseStyles } from './styles'
import { LinkedInArticleDisplayProps, LinkedInArticleProps } from './types'

const displays: { [key: string]: React.FC<LinkedInArticleDisplayProps> } = {
  default: DesktopSingle,
  desktopSingle: DesktopSingle,
  mobileSingle: MobileSingle,
}

const matchDisplay = (display: string): React.FC<LinkedInArticleDisplayProps> =>
  displays[display] || displays.default

export const LinkedInArticle: React.FC<LinkedInArticleProps> = ({
  accountImage,
  accountName,
  accountSubtitle,
  assets,
  display,
  externalAccessToken,
  isPresenting = false,
  isSnapshot = false,
  onExpandAsset,
  onPickAssets,
  onRemoveAsset,
  readOnly = false,
  richTextDocumentId,
  scheduledAt,
  timezone,
  title,
  updateCaption,
  updateText,
}) => {
  const RenderDisplay = matchDisplay(display)

  const [user] = useState<BackboneUserModel | undefined>(() =>
    getBackboneWindow().AppBase?.request<BackboneUserModel | undefined>(
      'users:get_current_user'
    )
  )

  return (
    <div
      css={baseStyles(display)}
      className={kuiperClassNames(
        'linkedin linkedin-article',
        `linkedin-${paramCase(display)}`
      )}
    >
      <RenderDisplay
        accountImage={accountImage}
        accountName={accountName}
        accountSubtitle={accountSubtitle}
        assets={assets.length > 0 ? [assets[0]] : []}
        currentUser={user}
        externalAccessToken={externalAccessToken}
        isPresenting={isPresenting}
        isSnapshot={isSnapshot}
        onAccountSubtitleChange={(val: string) =>
          updateText(val, 'account_subtitle')
        }
        onExpandAsset={onExpandAsset}
        onPickAssets={onPickAssets}
        onRemoveAsset={onRemoveAsset}
        onTitleChange={(val: string) => updateText(val, 'title')}
        readOnly={readOnly}
        richTextDocumentId={richTextDocumentId}
        scheduledAt={scheduledAt}
        timezone={timezone}
        title={title}
        updateCaption={updateCaption}
      />
    </div>
  )
}
